export default __webpack_public_path__ + "static/media/MaskGroup319.2ecc7376.png";